/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { FIELDS, FORM_DATA } from "./config/feedback-form";
import { UPDATE_FEEDBACK } from "../pages/ProductView/graphql/update-feedback.mutation";

const SERVICE_NAME = "feedback-form.service";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class FeedBackFormService {
    name = SERVICE_NAME;
    private static instance: FeedBackFormService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new FeedBackFormService();
        }
        return this.instance;
    }

    async feedbackForm(payload: any) {
        console.log(`payload in edit-product-info.service sss:`, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPDATE_FEEDBACK,
                    variables: {
                        ...{ ...payload },
                    },
                    fetchPolicy: "no-cache",
                });
                log.info(`fedback submitted:`, res?.data);
                return res?.data?.createContestEntryWeb;
            }
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
